import React, { useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../config/Config.js";
import { useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import PhaseTwoSevaModal from "../components/PhaseTwoSevaModal";

const LoginWithPassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const [phaseTwoUser, setPhaseTwoUser] = useState(null);
  const dispatch = useDispatch(); 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [emailerrormessage, setemailerrormessage] = useState("");
  const [passworderrormessage, setpassworderrormessage] = useState("");

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    var isemailerror = false;
    var ispassworderror = false;

    // if (!formData.email || !formData.password) {
    //   alert("Email and password are required");
    //   return;
    // }
    if(formData.email) {
      if(validateEmail(formData.email)) {
        isemailerror = false;
        setemailerrormessage("");
      } else {
        isemailerror = true;
        setemailerrormessage("Invalid Email ID");
      }
    } else {
      isemailerror = true;
      setemailerrormessage("Email ID cannot be empty");
    }

    if(formData.password) {
      ispassworderror = false;
      setpassworderrormessage("");
    } else {
      ispassworderror = true;
      setpassworderrormessage("Password cannot be empty");
    }

    if(!isemailerror && !ispassworderror) {
      // alert('valid');
    } else {
      // alert('Invalid');
      return;
    }
    setLoading(true);

    try {
      const res = await axios.post(
        apiUrl + "userlogin",
        {
          email: formData.email,
          password: formData.password
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (res.data.status === "success") {
        dispatch({ type: "customerdata", payload: res.data.data })
        if (res.data.data?.show_phase_two_seva_offer) {
          setPhaseTwoUser(res.data.data);
        } else {
          navigate("/createstory");
        }
      } else {
        alert(res.data.message || "Login failed");
      }
    } catch (err) {
      console.error(err);
      alert(
        "Error logging in: " +
          (err.response?.data?.message || err.message || "Network error.")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleRegisterClick = () => {
    navigate("/register"); // change to your actual register route
  };

  return (


    <>
      <PhaseTwoSevaModal
        show={Boolean(phaseTwoUser)}
        user={phaseTwoUser}
        onContinue={() => navigate("/createstory")}
        onPaymentSuccess={() => {
          dispatch({
            type: "customerdata",
            payload: {
              ...phaseTwoUser,
              show_phase_two_seva_offer: false,
              phase_two_seva_contributed: true,
            },
          });
          navigate("/createstory");
        }}
      />
<Helmet>
  {/* Meta Title */}
  <title>Login to TheOmSaga | Share Your Spiritual Stories</title>

  {/* Meta Description */}
  <meta
    name="description"
    content="Sign in to TheOmSaga to share your own spiritual stories, save the best spiritual stories you love and stay connected with a community of believers and seekers."
  />

  {/* Primary Keywords */}
  <meta
    name="keywords"
    content="spiritual stories, spiritual tale, spiritual story telling platform"
  />

  {/* Canonical Tag */}
  <link rel="canonical" href="https://theomsaga.com/login" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Login to TheOmSaga | Share Your Spiritual Stories"
  />
  <meta
    property="og:description"
    content="Sign in to TheOmSaga to share your own spiritual stories, save the best spiritual stories you love and stay connected with a community of believers and seekers."
  />
  <meta property="og:url" content="https://theomsaga.com/login" />
  <meta
    property="og:image"
    content="https://theomsaga.com/assets/images/login-banner.webp"
  />

  {/* Schema Markup */}
  <script type="application/ld+json">
    {`
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://theomsaga.com/login#webpage",
      "name": "Login to TheOmSaga",
      "url": "https://theomsaga.com/login",
      "description": "Login to TheOmSaga to share spiritual stories, save inspirational spiritual tales, and stay connected with a community of faith and seekers.",
       "sameAs": [
                  "https://www.instagram.com/theomsaga20?igsh=MWNnN3E0NGVleTltZw==",
                  "https://www.facebook.com/share/1B44vEtGc7/"
                ]
     
     
      "isPartOf": {
        "@type": "WebSite",
        "name": "TheOmSaga",
        "url": "https://theomsaga.com"
      }
    }
    `}
  </script>
</Helmet>



<div className="login-page-container">
      <div className="login-page-scroll loginwirhpassword-scroll">
        <div className="login-page-main-content">
          <div>
            <p className="onetime-text-login">One-time registration fee with lifetime access.</p>
            <p className="login-page-title">LOGIN / REGISTER</p>
          </div>

          <form className="login-page-form" onSubmit={handleSubmit}>
            <input
              className="login-page-input"
              type="text"
              name="email"
              placeholder="Email *"
              value={formData.email}
              onChange={handleChange}
            />
            {
                emailerrormessage ?
                <div className="login-page-input-error-div">
                   <p className="register-error-message" style={{textAlign: 'left'}}>{emailerrormessage}</p>
                </div>
                : null
              }
            <input
              className="login-page-input"
              type="password"
              name="password"
              placeholder="Password *"
              value={formData.password}
              onChange={handleChange}
            />
            {
                passworderrormessage ?
                <div className="login-page-input-error-div">
                   <p className="register-error-message" style={{textAlign: 'left'}}>{passworderrormessage}</p>
                </div>
                : null
              }
            <div className="forgetpassworddiv">
              <Link to={'/forget-password'}>Forgot Password ?</Link>
            </div>
            
            <button className="login-page-button" type="submit" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>

            <div className="ormaindiv">
                <div className="orborder"></div>
                <div className="ortextdiv">
                  <p className="ortext">OR</p>
                </div>
                <div className="orborder"></div>
              </div>

              <button
                className="login-page-button loginwithpasswordbtn"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/login');
                }}
              >
                Login with OTP
              </button>
          </form>

          <div className="login-page-mantra">
            <p>
            Haven’t registered yet?{" "}<br />
              <button
                type="button"
                className="login-page-registerlink"
                onClick={handleRegisterClick}
              >
                register now
              </button>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
    </>
  
  );
};

export default LoginWithPassword;
